import { render, staticRenderFns } from "./wqt-step-2a.vue?vue&type=template&id=21c78e39&"
import script from "./wqt-step-2a.vue?vue&type=script&lang=js&"
export * from "./wqt-step-2a.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports